import { Box, Paper, styled } from '@mui/material';
import { useEffect, type FC, type HTMLAttributes, type PropsWithChildren } from 'react';

import { errorStatusMessages } from '../../../router/reactErrorBoundary';
import { useZustand } from '../../../zustandStore';

const StyledPaper = styled(Paper)(({ theme }) => ({
	width: '100%',
	height: '100%',
	backgroundColor: theme.palette.tsGoColor.pink,
	color: theme.palette.tsGoColor.white,
}));

const StyledErrorBox = styled(Box)(() => ({
	left: '50%',
	transform: 'translateX(-50%) translateY(-50%)',
	top: '50%',
	position: 'absolute',
	margin: 'inherit',
	padding: 'inherit',
	border: 'none',
	borderColor: 'inherit',
}));

type ErrorPageProps = HTMLAttributes<HTMLElement> & { showPageNotFoundMessage?: boolean };

const ErrorPage: FC<PropsWithChildren<ErrorPageProps>> = ({ showPageNotFoundMessage = true }) => {
	const { setHeaderName } = useZustand();
	const { heading, message } = useZustand(state => state.error);

	useEffect(() => {
		setHeaderName('Tradeshift Go');
	}, [setHeaderName]);

	return (
		<StyledPaper>
			<StyledErrorBox>
				<h1>{showPageNotFoundMessage ? errorStatusMessages[404] : heading}</h1>
				<p>
					{showPageNotFoundMessage
						? 'You tried to access a page that does not exist. Please make sure you have the correct link.'
						: message}
				</p>
			</StyledErrorBox>
		</StyledPaper>
	);
};

export default ErrorPage;
